import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { GBENSContext } from '../GBENSContainer';

import Row from './_Row';

const DatePickerComponent = ({ id, screen, modal, name, toolTip, rowProps, disabled }) => {
  const { data, updateData, errors } = useContext(GBENSContext);
  const _error = errors?.[screen]?.[id] ? errors[screen][id] : null;
  return (
    <Row
      name={name}
      warning={_error}
      toolTip={toolTip}
      rowProps={rowProps}
      component={
        <div>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ marginRight: 20 }}>
              <DatePicker
                id={id + 'Date'}
                onChange={(e) => updateData(e, screen, id + 'Date', modal)}
                value={modal ? data?.[screen]?.[modal]?.[id + 'Date'] : data?.[screen]?.[id + 'Date']}
                format="DD/MM/YYYY"
                disabled={disabled}
              />
            </div>
          </div>
        </div>
      }
    />
  );
};

DatePickerComponent.propTypes = {
  id: PropTypes.string,
  screen: PropTypes.string,
  modal: PropTypes.string,
  name: PropTypes.string,
  toolTip: PropTypes.string,
  rowProps: PropTypes.object,
};

export default DatePickerComponent;
